import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

export const saveProductBulkCustomer = async (formData) => {
	const { data } = await axios.post(`${API_GO}/app/maintainer/products/attach_bulk`, {
		...formData,
	});
	return data;
};

export const updateProductPrice = async (formData) => {
	const { data } = await axios.post(`${API_GO}/app/maintainer/products/update/price`, {
		...formData,
	});
	return data;
};

export const recalculateProductPrice = async (formData) => {
	const { data } = await axios.post(
		`${API}/admin/products/recalculate_price`,
		{
			...formData,
			scope: "product_origin",
		},
		{
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		},
	);
	return data;
};
